import { Divider, MenuItem } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import React from "react";
import "./Profile.css";
import ProfileListItem from "./ProfileListItem";

import feedbackSvg from "../../assets/Icons/profile/new feedback_default.svg";
import feedbackSvgH from "../../assets/Icons/profile/new feedback_filled.svg";

import accountSvgH from "../../assets/Icons/profile/Account _ hover state.svg";
import accountSvg from "../../assets/Icons/profile/Account _ normal state.svg";
import logout from "../../assets/Icons/profile/Logout _ normal state.svg";
import UserGuide from "../../assets/Icons/profile/User Guide.svg";
import UserGuideH from "../../assets/Icons/profile/User Guide_hover.svg";
import privacyPolicySvg from "../../assets/Icons/profile/privacy-policy.svg";
import privacyPolicySvgH from "../../assets/Icons/profile/privacy-policy_hover.svg";
// import logoutH from "../../assets/Icons/profile/Logout _ hover state.svg"
import DefaultMaleProfilePic from "../../assets/Icons/profile/Profile icon _ male.png";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { roleToggler } from "../../redux-toolkit/features/access/accessSlice";
import {
  useSendLogoutMutation,
  useGetCompletedAlphaScreensQuery,
} from "../../redux-toolkit/features/auth/authApiSlice";
import { logoutAuth } from "../../redux-toolkit/features/auth/authSlice";
import {
  logoutTheme,
  setStep,
  setTourActive,
} from "../../redux-toolkit/features/theme/themeSlice";

const profileListItems = [
  {
    name: "Account",
    guide: "step15",
    icon: accountSvg,
    iconOnHover: accountSvgH,
    link: "/quest/account",
  },
  // {
  //   name: "My Activity",
  //   icon: notificationProfileSvg,
  //   iconOnHover: notificationProfileSvgH,
  //   link: "/quest/my-activity",
  // },
  {
    name: "Quest Walkthrough",
    icon: UserGuide,
    iconOnHover: UserGuideH,
    link: "",
  },
  {
    name: "Privacy & Terms",
    icon: privacyPolicySvg,
    iconOnHover: privacyPolicySvgH,
    link: "/privacy-policy",
    newTab: true,
  },
  {
    name: "Feedback",
    icon: feedbackSvg,
    guide: "step18",

    iconOnHover: feedbackSvgH,
    // link: '/quest/my-activity',
  },
];

const rolesList = [
  {
    label: "Employee",
    link: "/quest",
    access: [
      "ADMIN_COURSES",
      "ADMIN_BOOKS",
      "ADMIN_TASK_VER",
      "ADMIN_REPORTS",
      "SUPERADMIN_BOOKS",
      "SUPERADMIN_TIMETRIAL",
      "SUPERADMIN_EMPLOYEES",
      "SUPERADMIN_COMPANY",
      "SUPERADMIN_THEMES",
      "SUPERADMIN_REPORTS",
      "SUPERADMIN_TASK",
      "SUPERADMIN_REWARDS",
    ],
  },
  {
    label: "Admin",
    link: "/admin",
    links: {
      ADMIN_COURSES: "/admin/my-workspace",
      ADMIN_BOOKS: "/admin/my-workspace",
      ADMIN_TASK_VER: "/admin/manage-company/task-verification",
      ADMIN_REPORTS: "/admin",
      ADMIN_EMPLOYEES: "/admin/manage-company/employee",
    },
    access: [
      "ADMIN_COURSES",
      "ADMIN_BOOKS",
      "ADMIN_TASK_VER",
      "ADMIN_REPORTS",
      "ADMIN_EMPLOYEES",
    ],
  },
  {
    label: "Super Admin",
    link: "/super-admin",
    links: {
      SUPERADMIN_BOOKS: "/super-admin/manage-organization/organizational-workspace",
      SUPERADMIN_TIMETRIAL: "/super-admin/manage-organization/organizational-workspace",
      SUPERADMIN_EMPLOYEES: "/super-admin/manage-organization/employee",
      SUPERADMIN_COMPANY: "/super-admin/manage-organization/companies",
      SUPERADMIN_THEMES: "/super-admin/manage-organization/themes",
      SUPERADMIN_REPORTS: "/super-admin",
      SUPERADMIN_TASK: "/super-admin/manage-organization/task-verification",
      SUPERADMIN_REWARDS: "/super-admin/rewards",
    },
    access: [
      "SUPERADMIN_BOOKS",
      "SUPERADMIN_TIMETRIAL",
      "SUPERADMIN_EMPLOYEES",
      "SUPERADMIN_COMPANY",
      "SUPERADMIN_THEMES",
      "SUPERADMIN_REPORTS",
      "SUPERADMIN_TASK",
      "SUPERADMIN_REWARDS",
    ],
  },
];

/** First permission in allowedAccess that has a route in linksMap; otherwise defaultLink. */
function firstMappedRolePath(allowedAccess, linksMap, defaultLink) {
  if (!allowedAccess?.length || !linksMap) return defaultLink;
  const key = allowedAccess.find((k) => linksMap[k]);
  return key ? linksMap[key] : defaultLink;
}

const profileDown = [
  {
    target: "#step0",
    title: "kickstart",
    content:
      "Specific users have permissions to switch the access. This access can allow you to monitor the users and create an engaging platform. ",
  },
  {
    target: "#step16",
    title: "Switch View",
    content:
      "Specific users have permissions to switch the access. This access can allow you to monitor the users and create an engaging platform. ",
  },
  {
    target: "#step15",
    title: "Account",
    content:
      "Here you can do basic settings on your account. You can also check your activity and overall performance. ",
  },
  {
    target: "#step18",
    title: "Feedback",
    content: "Submit your feedback at your convenience.",
  },
];

export const Profile = ({ theme, toggleDrawer }) => {
  const selectedRole = useSelector((state) => state.access.selectedRole);
  const dispatch = useDispatch();

  const [role, setRole] = React.useState(
    rolesList.filter((item) => item.label === selectedRole)[0],
  );

  const [allRole, setAllRole] = React.useState([]);

  const [sendLogout] = useSendLogoutMutation();
  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.user);

  const { data: alphaScreens } = useGetCompletedAlphaScreensQuery({
    refetchOnMountOrArgChange: true,
  });

  const logoutHandler = async () => {
    try {
      await sendLogout().unwrap();
    } catch (err) {
      // Server may be down; local session is still cleared below.
    } finally {
      dispatch(logoutTheme());
      dispatch(logoutAuth());
      // Final wipe after theme/auth resets (persistor is paused on logout).
      localStorage.clear();
      sessionStorage.clear();
      navigate("/login");
    }
  };

  React.useEffect(() => {
    if (selectedRole) {
      setRole(rolesList.filter((item) => item.label === selectedRole)[0]);
    }
  }, [selectedRole]);

  const roleHandler = async (event) => {
    const { label, link, links } = event.target.value;
    await setRole(label);
    dispatch(roleToggler(label));
    if (!user?.allowedAccess.includes("ADMIN_REPORTS") && label === "Admin") {
      let path = firstMappedRolePath(user?.allowedAccess, links, link);
      if (
        path === "/admin/manage-company/employee" &&
        user?.companyId
      ) {
        path = `${path}/${user.companyId}`;
      }
      navigate(path);
    } else if (
      !user?.allowedAccess.includes("SUPERADMIN_REPORTS") &&
      label === "Super Admin"
    ) {
      navigate(firstMappedRolePath(user?.allowedAccess, links, link));
    } else navigate(link);
  };

  React.useEffect(() => {
    const filteredRolesList = rolesList.filter((role) => {
      return role.access.some((access) => user?.allowedAccess.includes(access));
    });
    setAllRole(filteredRolesList);
  }, [user]);

  // Alpha screens / auto tours are disabled on login.
  const showScreen = React.useCallback((_screen) => false, []);

  React.useEffect(() => {
    // Wait for alphaScreens data to be available before making decisions
    // This prevents false positives when data is still loading
    if (alphaScreens === undefined) {
      return; // Still loading, wait
    }

    // Only set steps if the tour should be shown
    // This prevents the marker from appearing when tour shouldn't run
    if (showScreen("PROFILE_DD")) {
      dispatch(setStep(profileDown));

      const timeoutId = setTimeout(() => {
        // Double-check before activating tour (in case data changed during timeout)
        if (showScreen("PROFILE_DD")) {
          dispatch(setTourActive(true));
        }
      }, 500);

      return () => {
        clearTimeout(timeoutId);
      };
    } else {
      // Clear steps if already completed to prevent marker from showing
      dispatch(setStep([]));
      dispatch(setTourActive(false));
    }
  }, [alphaScreens, dispatch, showScreen]);

  return (
    <div className="profile">
      <div className="profile__head">
        <Avatar
          alt="Remy Sharp"
          sx={{ width: "65px", height: "65px" }}
          src={user?.avatar ? user?.avatar : DefaultMaleProfilePic}
        />
        <div className="profile__headcontent">
          <div className="profile__headcontent__item">
            <h6>
              {user?.fname} {user?.lname}
            </h6>
          </div>
          <div className="profile__headcontent__item">
            <p style={{ fontWeight: "600" }}>ID: {user?.employeeId}</p>
          </div>

          {(user?.role === "CUSTOM_ROLE" ||
            user?.role === "ADMIN" ||
            user?.role === "SUPERADMIN") && (
            // <div id="step6">
            <FormControl id="step16" sx={{ width: "90%", marginTop: "5px" }}>
              <Select
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                labelId="demo-simple-select-autowidth-label"
                id="demo-simple-select-autowidth "
                value={role}
                onChange={roleHandler}
              >
                {allRole?.map((item, index) => {
                  return (
                    <MenuItem
                      onClick={toggleDrawer("top", false)}
                      sx={{ fontSize: "14px" }}
                      key={index}
                      value={item}
                    >
                      {item.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            // </div>
          )}
        </div>
      </div>
      <Divider variant="fullWidth" sx={{ my: "10px" }} />{" "}
      <div>
        <ul>
          {profileListItems.map((item, index) => {
            if (item.hidden && item.hidden(user)) return null;
            return (
              <div
                id={item.name === "Account" ? "step4" : undefined}
                onClick={toggleDrawer("top", false)}
                key={index}
              >
                <ProfileListItem
                  index={index}
                  name={item.name}
                  icon={item.icon}
                  iconOnHover={item.iconOnHover}
                  link={item.link}
                  guide={item.guide}
                  theme={theme}
                  role={role}
                  newTab={item.newTab}
                />
              </div>
            );
          })}
        </ul>
      </div>
      <Divider variant="fullWidth" sx={{ my: "10px" }} />{" "}
      <div onClick={logoutHandler} className="profile__logout">
        <ul>
          <ProfileListItem
            name={"Log Out"}
            icon={logout}
            iconOnHover={logout}
            link={"logout"}
            theme={theme}
          />
        </ul>
      </div>
    </div>
  );
};
